<template>
  <div
    class="shadow-xs border border-gray-200 rounded-lg cursor-pointer transition-shadow duration-300 ease-in-out hover:shadow-md"
  >
    <div class="flex items-center w-full p-3">
      <Avatar
        size="md"
        type="square"
        :icon="props.addon.data?.refillPeriod === 'monthly' ? 'infinity' : 'package-plus'"
        class="border-none"
        :class="props.addon.status === 'active' ? 'bg-green-100 [&_svg]:text-green-500' : ''"
      />
      <div class="flex-1 flex items-center">
        <div class="mx-3 sm:w-40">
          <div class="text-xs text-gray-600">
            {{ props.addon.data?.refillPeriod === 'monthly' ? useT('addon.period.monthly') : useT('addon.period.oneTime') }}
          </div>
          <div class="text-sm font-medium text-gray-900">
            {{ tierLabel }}
          </div>
        </div>
      </div>
      <div class="flex items-end lg:items-center flex-col lg:flex-row gap-y-1">
        <div
          v-if="props.addon.expiringAt"
          class="lg:w-64 lg:px-3 text-sm text-gray-600 text-right lg:text-left"
        >
          {{ useT('addon.expiresOn') }}
          {{ getFormattedDate(props.addon.expiringAt, {
            lang: useAuthStore().user?.locale,
            format: 'll',
          }) }}
        </div>
        <div class="lg:w-32">
          <Badge
            :text="_upperFirst(props.addon.status)"
            :type="statusTypeMap[props.addon.status]"
          />
        </div>
        <div
          class="text-gray-500 text-sm text-right px-3 w-32 truncate"
        >
          {{ useT('addon.xCredits', { value: props.addon.data?.credits || 0 }) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  addon: {
    type: Object,
    required: true,
  },
});

const statusTypeMap = {
  active: 'success',
  expired: 'warning',
  used: 'neutral',
  deactivated: 'critical',
};

// Tier label is derived from the credit count — the source of truth lives
// in the addon doc as a number; the console maps that back to the tier
// label users picked at create time.
const tierLabel = computed(() => {
  const credits = props.addon.data?.credits;
  if (credits === 50) return useT('addon.tier.start');
  if (credits === 150) return useT('addon.tier.plus');
  if (credits === 500) return useT('addon.tier.max');
  return `${credits || 0}`;
});
</script>
